const shadow = {
  "shadow-none": {
    value: "none"
  },
  "shadow-sm": {
    displayText: "Card",
    value: "0px 0px 1px 0px rgba(0, 0, 0, 0.16), 0px 1px 4px 0px rgba(0, 0, 0, 0.04)"
  },
  "shadow-md": {
    displayText: "Popover, Panel, Modal",
    value: "0px 8px 16px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.08)"
  },
  "shadow-lg": {
    displayText: "Decorative only",
    value: "0px 16px 32px 0px rgba(0, 0, 0, 0.10), 0px 0px 4px 0px rgba(0, 0, 0, 0.04)"
  }
};
export {
  shadow
};
//# sourceMappingURL=shadow.es.js.map
